import React, { createContext, useContext, useState, useEffect } from 'react'

interface User { id: string; email: string; name: string }
interface AuthCtx {
  user: User | null
  token: string | null
  login: (token: string, user: User) => void
  logout: () => void
  loading: boolean
}

const Ctx = createContext<AuthCtx>({
  user: null, token: null,
  login: () => {}, logout: () => {}, loading: true
})

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user,    setUser]    = useState<User | null>(null)
  const [token,   setToken]   = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  // Restore session from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('rdp_token')
    if (stored) {
      fetch('/api/auth/me', { headers: { Authorization: `Bearer ${stored}` } })
        .then(r => r.json())
        .then(data => {
          if (data.user) { setToken(stored); setUser(data.user) }
          else localStorage.removeItem('rdp_token')
        })
        .catch(() => localStorage.removeItem('rdp_token'))
        .finally(() => setLoading(false))
    } else {
      setLoading(false)
    }
  }, [])

  const login = (t: string, u: User) => {
    localStorage.setItem('rdp_token', t)
    setToken(t); setUser(u)
  }

  const logout = () => {
    localStorage.removeItem('rdp_token')
    setToken(null); setUser(null)
  }

  return <Ctx.Provider value={{ user, token, login, logout, loading }}>{children}</Ctx.Provider>
}

export const useAuth = () => useContext(Ctx)
